import React, { useState } from "react";

import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import EditIcon from "@mui/icons-material/Edit";
import EmailIcon from "@mui/icons-material/Email";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import {
  Box,
  FormControl,
  Menu,
  MenuItem,
  Stack,
  TableHead,
  TextField,
  Tooltip,
  Zoom,
} from "@mui/material";

import { Loader } from "../../common/loader";
import { PER_PAGE } from "../../helpers/constants";
import DeleteModal from "../../common/DeleteModal";
import AlertDialog from "../../common/AlertDialog";
import download from "../../../assets/icons/download.png";
import SettingsIconSVG from "../../common/SettingsIconSVG";
import { getFormatedPhoneNumber, getObjLength } from "../../helpers/utils";
import { StyledTableCell, StyledTableRow } from "../../investor/list/ListTable";
import { agentsAdminAction } from "../../../redux/slices/brokers/agentAdminSlice";
import CustomPagination from "../../common/customDesignedComponents/CustomPagination";
import { propertyUsersAction } from "../../../redux/slices/admin/propertyUsers/propertyUsersSlice";

const CommonAgentsAdminTable = ({
  noheaders = false,
  rowData = [],
  columns = [],
  btn_texts = "",
  addBtnClick = () => {},
  pageCount = 0,
  payload = {},
  setPayload = () => {},
  handleViewIconBtn = () => {},
  setEditRecord = () => {},
  setSelectedProperty = () => {},
  selectedProperty = null,
  deleteAPIURL = "",
  listAPICall = () => {},
  customeDeleteMessage = null,
  statusList = [],
  updateAgentStatus = () => {},
  tabelMinWidth = 1100,
  isRepresentative = false,
  base_route = "broker",
  isSuperAdmin = false,
  isResendWelcomeEmailOption = true,
}) => {
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [deletePropetyModal, setDeletePropetyModal] = useState(false);
  const [resendWelcomeEmail, setResendWelcomeEmail] = useState(false);

  const { updateAgentStatusDetails } = useSelector(
    (state) => state?.agentsAdmin
  );

  const {
    deletePropertyData,
    deletePropertyLoader,
    resendWelcomeEmailLoader,
    resendWelcomeEmailDetails,
  } = useSelector((state) => state?.propertyUsers);

  const { salesRepresentativeList, tabValueName } = useSelector(
    (state) => state?.agentsAdmin
  );

  const { brokerDetails } = useSelector((state) => state?.brokerAgents);

  const officeList = brokerDetails?.success
    ? brokerDetails?.data?.broker?.offices
    : [];

  const handleDeleteProeprty = () => {
    let data = {};
    if (isSuperAdmin) {
      data = { ...data, from_super_admin: true };
    }
    if (selectedProperty?.id) {
      dispatch(
        propertyUsersAction.getDeletePropertyData({
          url: `${deleteAPIURL}/${selectedProperty?.id}?source=${base_route}`,
          data,
          brokertoken: !isSuperAdmin,
          token: isSuperAdmin,
          type: "delete",
        })
      );
    }
  };

  const handleDeleteProeprtyOption = (type = false) => {
    setDeletePropetyModal(type);
    dispatch(propertyUsersAction.clearDeletePropertyData({}));
  };

  const handleReSendWelcomeEmail = () => {
    console.log("selectedRow", selectedProperty);

    dispatch(
      propertyUsersAction.resendWelcomeEmailData({
        url: `agent/resend-welcome-email/${selectedProperty?.id}`,
        data: {},
        brokertoken: !isSuperAdmin,
        token: isSuperAdmin,
      })
    );
    setResendWelcomeEmail(false);
  };

  const handleMenuClick = (event, data) => {
    setSelectedProperty(data);
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handlePageChange = (e, p) => {
    setPage(p);
    setPayload((prevState) => ({
      ...prevState,
      offset: (p - 1) * PER_PAGE,
    }));
  };
  const handleFileDownload = (fileLink) => {
    const link = document.createElement("a");
    link.href = fileLink;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <>
      <TableContainer
        component={Paper}
        className=""
        sx={{
          //  maxHeight: 885,
          boxShadow: isSuperAdmin ? "" : "0px 1px 0px 0px #344B5B0F",
        }}
        aria-labelledby="tableTitle"
        stickyHeader
      >
        <Table
          sx={{ minWidth: isSuperAdmin ? 750 : tabelMinWidth }}
          stickyHeader
          aria-label="sticky table"
        >
          {!noheaders && (
            <TableHead>
              <TableRow>
                {columns?.map((col, index) => (
                  <StyledTableCell
                    head__bg={isSuperAdmin ? "" : "#F3F4F5"}
                    key={index}
                    minWidth={col?.minWidth}
                    maxWidth={col?.maxWidth}
                    width={col?.width}
                    wordWrap={col?.wordWrap}
                  >
                    {col?.label}
                  </StyledTableCell>
                ))}
              </TableRow>
            </TableHead>
          )}

          <TableBody>
            {rowData?.map((row, index) => {
              return (
                <>
                  <StyledTableRow key={index}>
                    {columns?.map((col, colIndex) => (
                      <StyledTableCell
                        key={colIndex}
                        minWidth={col?.minWidth}
                        maxWidth={col?.maxWidth}
                        width={col?.width}
                        bodypadding={col?.bodypadding}
                        alignProp={col?.alignProp}
                        wordWrap={col?.wordWrap}
                        wordBreak={col?.wordBreak}
                      >
                        {col.id === "action" ? (
                          <IconButton
                            onClick={(event) => {
                              event.stopPropagation();
                              handleMenuClick(event, row);
                            }}
                            size="small"
                            className="settings-button"
                            aria-haspopup="true"
                          >
                            <SettingsIconSVG color={"#15BE53"} />
                          </IconButton>
                        ) : col.id === "srr" ? (
                          <>
                            {(payload?.offset + index + 1) % 2 !== 0 ? (
                              <Tooltip
                                title={col?.tooltipMsg}
                                TransitionComponent={Zoom}
                                placement="top"
                                arrow
                              >
                                <VerifiedUserIcon
                                  sx={{ textAlign: "center", color: "#0fd018" }}
                                />
                              </Tooltip>
                            ) : null}
                          </>
                        ) : col.id === "sr" ? (
                          `${payload?.offset + index + 1}${
                            !isSuperAdmin ? "." : ""
                          }`
                        ) : col.id === "static" ? (
                          col.staticText
                        ) : col.id === "view" ? (
                          <Tooltip
                            title={col?.tooltipMsg}
                            TransitionComponent={Zoom}
                            placement="top"
                            arrow
                          >
                            <Button
                              variant="text"
                              onClick={() => handleViewIconBtn(row)}
                              style={{ ...col?.sx }}
                            >
                              {col?.content}
                            </Button>
                          </Tooltip>
                        ) : col.id === "resend-email" ? (
                          <Tooltip
                            title={col?.tooltipMsg}
                            TransitionComponent={Zoom}
                            placement="top"
                            arrow
                          >
                            <Button
                              variant="text"
                              onClick={() => {
                                setSelectedProperty(row);
                                setResendWelcomeEmail(true);
                              }}
                              style={{ ...col?.sx }}
                            >
                              {col?.content}
                            </Button>
                          </Tooltip>
                        ) : col.copyIcon ? (
                          row[col.id] ? (
                            <Tooltip
                              title={`${row[col.id]}`}
                              TransitionComponent={Zoom}
                              placement="top"
                              arrow
                            >
                              <IconButton
                                sx={{
                                  color: "#0395FF",
                                  fontSize: "1.4rem",
                                  cursor: "pointer",
                                  padding: 0,
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigator.clipboard.writeText(row[col.id]);
                                }}
                              >
                                <ContentCopyIcon />
                              </IconButton>
                            </Tooltip>
                          ) : (
                            "-"
                          )
                        ) : col.mergeIds ? (
                          `${row[col.id1] || "0"}/${row[col.id2] || "0"}`
                        ) : col.id === "phone" ? (
                          getFormatedPhoneNumber(row[col.id]) || "-"
                        ) : col.displayChip ? (
                          <p
                            className={`mb-0 proeprty_status billing_payment_status sent ${
                              row[col.id]
                            }`}
                          >
                            {row[col.id]}
                          </p>
                        ) : col.fileDownload ? (
                          <>
                            {row[col.verify_id] === col.verify_Value ? (
                              <Button
                                variant="outlined"
                                className="file_dwn"
                                onClick={() => handleFileDownload(row[col.id])}
                              >
                                Download <img src={download} alt="file" />
                              </Button>
                            ) : (
                              "-"
                            )}
                          </>
                        ) : col?.dropdown ? (
                          !isRepresentative ? (
                            <FormControl className="filter-select-one w-100 p-0">
                              <TextField
                                className="status_dropdown agent_status"
                                id="outlined-select-currency"
                                select
                                value={
                                  col?.id === "rep_name"
                                    ? row?.rep_id
                                    : col?.id === "office_name"
                                    ? row?.office_id
                                    : row[col.id]
                                }
                                onChange={(e) => {
                                  updateAgentStatus(
                                    e.target.value,
                                    col.id,
                                    row
                                  );
                                }}
                              >
                                {col?.id === "agent_status" &&
                                  statusList?.map((status, key) =>
                                    status?.id === "pending" ? (
                                      <MenuItem
                                        value={status.id}
                                        disabled
                                        className="d-none"
                                      >
                                        <span className={`${status.id}`}>
                                          {status.label}
                                        </span>
                                      </MenuItem>
                                    ) : (
                                      <MenuItem value={status.id}>
                                        <span style={{ color: status?.color }}>
                                          {status.label}
                                        </span>
                                      </MenuItem>
                                    )
                                  )}
                                {col?.id === "rep_name" &&
                                  salesRepresentativeList?.data?.map(
                                    (res, key) => (
                                      <MenuItem value={res?.id}>
                                        <span>{res?.full_name}</span>
                                      </MenuItem>
                                    )
                                  )}
                                {col?.id === "office_name" &&
                                  officeList?.map((office, key) => (
                                    <MenuItem value={office?.id}>
                                      <span>{office?.office_name}</span>
                                    </MenuItem>
                                  ))}
                              </TextField>
                            </FormControl>
                          ) : (
                            <span className={`agent_status ${row[col?.id]}`}>
                              {row[col.id]}
                            </span>
                          )
                        ) : (
                          row[col.id] ?? "-"
                        )}
                      </StyledTableCell>
                    ))}
                  </StyledTableRow>
                </>
              );
            })}
          </TableBody>
        </Table>

        {!rowData?.length > 0 && (
          <Typography className="p-5 text-center" variant="h6">
            {"No Data Found."}
          </Typography>
        )}
      </TableContainer>
      {pageCount > 1 && (
        <Box className="mt-5" id="pagination-container">
          <CustomPagination
            count={pageCount}
            page={page}
            handlePageChange={handlePageChange}
          />
        </Box>
      )}

      {/* Menu Options */}
      <Menu
        // key={index}
        anchorEl={anchorEl}
        id="settings-menu"
        open={open}
        onClose={handleMenuClose}
        onClick={handleMenuClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.1))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
          },
        }}
        transformOrigin={{
          horizontal: "center",
          vertical: "top",
        }}
        anchorOrigin={{
          horizontal: "right",
          vertical: "bottom",
        }}
      >
        <MenuItem
          key="premium_subscription"
          onClick={setEditRecord}
          className="setting-menu-item"
        >
          <Box className="setting-menu-box">
            <EditIcon />
            <Typography className="setting-menu-text">
              Edit {tabValueName}
            </Typography>
          </Box>
        </MenuItem>
        <MenuItem
          key="premium_subscription"
          onClick={() => handleDeleteProeprtyOption(true)}
          className="setting-menu-item"
        >
          <Box className="setting-menu-box">
            <DeleteOutlineIcon />
            <Typography className="setting-menu-text">
              Delete {tabValueName}
            </Typography>
          </Box>
        </MenuItem>
        {isResendWelcomeEmailOption && (
          <MenuItem
            key="premium_subscription"
            onClick={() => setResendWelcomeEmail(true)}
            className="setting-menu-item"
          >
            <Box className="setting-menu-box">
              <EmailIcon />
              <Typography className="setting-menu-text">
                Resend Welcome Email
              </Typography>
            </Box>
          </MenuItem>
        )}
      </Menu>

      {!isSuperAdmin && btn_texts && (
        <div className="agents_buttons justify-content-center mt-5">
          <Button onClick={addBtnClick} className="save-agents-btn">
            {btn_texts}
          </Button>
        </div>
      )}

      {/* Delete Record */}
      {deletePropetyModal && (
        <DeleteModal
          open={deletePropetyModal}
          title="Delete Property"
          item="Property"
          deleteLoader={deletePropertyLoader}
          handleClose={() => handleDeleteProeprtyOption(false)}
          handleDeleteBtn={handleDeleteProeprty}
          fetchedData={deletePropertyData}
          isDeleteSuccess={deletePropertyData?.success}
          successMessage={deletePropertyData?.message}
          errorMessage={deletePropertyData?.data?.message}
          callListingAPI={listAPICall}
          customeMessage={customeDeleteMessage}
        />
      )}

      {/* success or error resend postcard API */}
      {getObjLength(updateAgentStatusDetails) ? (
        <AlertDialog
          type={updateAgentStatusDetails?.success ? "Success" : "Error"}
          openPopup={true}
          onClose={true}
          onCloseFun={() => {
            dispatch(agentsAdminAction.fetchUpdateAgentStatusData({}));
            if (updateAgentStatusDetails?.success) {
              listAPICall(0); //set offset 0
              setPage(1);
            }
            window.scrollTo(0, 0);
          }}
          mesage={
            updateAgentStatusDetails?.success
              ? updateAgentStatusDetails?.message
              : updateAgentStatusDetails?.data?.message ||
                updateAgentStatusDetails?.error
          }
          footer={false}
        />
      ) : null}

      {/* Resend Welcome email modal */}
      {resendWelcomeEmail ? (
        <AlertDialog
          type={"Warning"}
          openPopup={resendWelcomeEmail}
          onClose={true}
          onCloseFun={() => {
            setResendWelcomeEmail(false);
          }}
          mesage={`Are you sure you want to Resend the Welcome Email?`}
          buttons={
            <>
              <Stack direction="row" justifyContent="center" spacing={2}>
                <Button
                  className="popup_Btn other_popup_btn"
                  onClick={() => {
                    setResendWelcomeEmail(false);
                  }}
                >
                  No
                </Button>
                <Button
                  className="popup_Btn success_popup_btn"
                  onClick={handleReSendWelcomeEmail}
                >
                  Yes
                </Button>
              </Stack>
            </>
          }
          footer={false}
          loader={resendWelcomeEmailLoader}
        />
      ) : null}

      {getObjLength(resendWelcomeEmailDetails) && (
        <AlertDialog
          type={resendWelcomeEmailDetails?.success ? "Success" : "Error"}
          openPopup={true}
          onClose={true}
          onCloseFun={() => {
            dispatch(propertyUsersAction.fetchResendWelcomeEmailData({}));
          }}
          mesage={
            resendWelcomeEmailDetails?.success
              ? resendWelcomeEmailDetails?.message
              : resendWelcomeEmailDetails?.data?.message
          }
          footer={false}
        />
      )}
      <Loader open={resendWelcomeEmailLoader} />
    </>
  );
};

export default CommonAgentsAdminTable;
